module.exports = __webpack_public_path__ + "img/help7.5476ea60.png";